export default __webpack_public_path__ + "static/media/landing-right.3a2eb83b.jpg";